/*
 * @Author: bbqin
 * @Date: 2022-01-11 14:45:55
 * @LastEditTime: 2023-11-14 20:21:05
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\compatible.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from 'react';
import SmartCard from './index';
import { Preset, isArray, uniqueId, isFunction, runInterval } from './libs/utils';
import { pageTo, getSysFieldid, getGlobalStorage } from '@platform/api';
import Message from './components/message';
import Portal from './components/portal';

const empty = function () { };

const { useSmartCard } = SmartCard;

/**
 * @namespace SmartCard
 */

/**
 * 判断是否存在store
 * @ignore
 * @memberof SmartCard
 * @param {string} moduleId
 * @returns {Object}
 */
function getStore(moduleId) {
    if (!moduleId) {
        console.log('请传入正确的moduleId');
        return;
    }
    if (this.smartCardDataSource && this.smartCardDataSource[moduleId]) {
        return this.smartCardDataSource[moduleId];
    } else {
        // 暂时通过error 提醒业务组、 稳定后可去掉
        // throw Error(`正在调用ID为${moduleId}的卡片容器的API, 但此卡片容器还未通过use.smartCard注册,请先注册此ID，才能正常调用API`);
        this.smartCardDataSource = this.smartCardDataSource || {};
        this.smartCardDataSource[moduleId] = useSmartCard({ id: moduleId });

        let uniqueStore = this.smartCardDataSource[uniqueId];
        // 根据ts 判断用户级缓存
        if (!uniqueStore) {
            // 先走了getStore
            this.smartCardDataSource[uniqueId] = uniqueStore = useSmartCard({ id: uniqueId });
        }

        const meta = uniqueStore.getMeta() || [];
        const metaLang = uniqueStore.getMetaLang();
        const currentTs = uniqueStore.getStore('ts');

        // 如果模板没有且没有ts说明模板还没有加载，此时不应该重置模板
        if (meta.length && currentTs) {
            this.smartCardDataSource[moduleId].setStore('ts', currentTs, false);
            this.smartCardDataSource[moduleId].setMetaLang(metaLang);
            this.smartCardDataSource[moduleId].setMeta(meta, moduleId);
        }

        return this.smartCardDataSource[moduleId];
    }
}

// 页面状态 上一次
let mountStatusCache = false;

/**
 * 初始化模板
 * @ignore
 * @memberof SmartCard
 * @param {object} meta
 */
function init(meta) {
    const { smartCardDataSource = {} } = this;
    const stores = Object.keys(smartCardDataSource);

    // 取出layout数据用于渲染
    let layout = meta?.flatLayout;

    // 告诉页面是否有
    if (Object.keys(meta).length && !mountStatusCache) {
        // 不稳定，移除
        // runInterval(() => {
        //     const smartCard = document.querySelector('.smart-card-wrapper');
        //     // mountStatusCache = true;
        //     if (!smartCard) {
        //         // 没有绑定
        //         Message.publish(Message.getName('mount'), { mounted: false });
        //     }
        // }, () => {
        //     const smartCard = document.querySelector('.smart-card-wrapper');
        //     return smartCard;
        // }, 100, 10);
    }

    if (!layout) {
        console.log('未识别到smartCard相关模板信息！');
        return;
    }
    // 转型为对象形式
    // layout = JSON.parse(layout);
    //在这里进行新layout转旧的layout
    if (Array.isArray(layout) && layout[0] && !layout[0]['path']) {
        let smartcard = layout.filter(i => i.code === 'nc-lightapp-front,SmartCardContainer');
        // let sTab = layout.filter(i => i.code === 'LowCodeComponents.SmartCardContainer.SmartCardContainerItem').map(i => { i.path = 'LowCodeComponents.SmartCardContainer.SmartCardContainerItem'; i.parentId = i.pid; i.$id = i.id; return i; });
        // let sCard = layout.filter(i => i.code === 'nc-lightapp-front,SmartCardWallet').map(i => { i.path = 'LowCodeComponents.SmartCardWallet'; i.parentId = i.pid; i.$id = i.id; return i; });
        // let sCom = layout.filter(i => i.code.includes('/index')).map(i => { i.path = i.code; i.parentId = i.pid; i.$id = i.id; return i; });
        let tlayout = [...smartcard];
        smartcard.forEach(card => {
            //处理页签
            let tabs = card.props?.tabs;
            if (Array.isArray(tabs)) {
                tabs.forEach(({ cards: wallets, ...tab }) => {
                    let tabnode = {
                        path: 'LowCodeComponents.SmartCardContainer.SmartCardContainerItem',
                        props: { ...tab },
                        parentId: card.id,
                        $id: tab.moduleId,
                    };
                    tlayout.push(tabnode);
                    //处理卡片夹
                    if (Array.isArray(wallets)) {
                        wallets.forEach(({ moduleId, children, ...others }) => {
                            let walletsnode = {
                                path: "LowCodeComponents.SmartCardWallet",
                                parentId: tab.moduleId,
                                $id: moduleId,
                                props: { ...others },
                            };
                            tlayout.push(walletsnode);
                            //处理卡片
                            let cards = children?.value;
                            if (Array.isArray(cards)) {
                                cards.forEach(card => {
                                    let cardnode = {
                                        path: card.code?.split(',')[0],
                                        parentId: moduleId,
                                        $id: card.id,
                                        props: card.props,
                                    };
                                    tlayout.push(cardnode);
                                });
                            }
                        });
                    }
                });
                
            }
        });
        layout = tlayout;
    }

    // 创建一个默认的， 用于解决init和getStore顺序不一定一致的问题
    if (!smartCardDataSource[uniqueId]) {
        stores.push(uniqueId);
        this.smartCardDataSource = this.smartCardDataSource || {};
        this.smartCardDataSource[uniqueId] = smartCardDataSource[uniqueId] = useSmartCard({ id: uniqueId });
    }

    // 预先创建store 避免store丢失
    layout.forEach &&
        layout.forEach(element => {
            const { $id, path, props = {}, parentId: currentParentId } = element;
            const { moduleId, visible } = props || {};
            const isSmartContainer = this.smartCardDataSource[uniqueId].isSmartContainer(path);
            if (isSmartContainer && !this.smartCardDataSource[moduleId]) {
                stores.push(moduleId);
                this.smartCardDataSource[moduleId] = smartCardDataSource[moduleId] = useSmartCard({ id: moduleId });
            }
        });

    // 根据ts 判断用户级缓存
    const currentTs = meta?.ts;
    const prevMetaLang = smartCardDataSource[uniqueId].getMetaLang() || {};
    // 多语
    const multiLangItems = meta?.multiLangItems || [];
    let metaLang = multiLangItems.reduce((accumulator, current, index, arr) => {
        const { moduleid } = current;
        accumulator[moduleid] = current;
        return accumulator;
    }, prevMetaLang);

    // 监控数值的变化
    const metaJson = meta?.metaJson;
    if (metaJson) {
        const { billtype, head = {}, headcode } = metaJson;
        const { clazz, metaid, pk, billfield = {} } = head;
        const { approvestate = {}, billtype: sameBillType, transtype } = billfield;
        let { statusField, statusValue } = approvestate;
        const formListenerField = this.smartCardDataSource[uniqueId].getStore('formListenerField') || {};
        if (this.formDataSource && this.formDataSource[headcode] && pk) {
            const that = this;
            const _billtype = billtype;

            // 避免表单字段的意外情况，给一个可配置的入口
            const currentStatusField = formListenerField.approvestate || statusField;

            // 避免表单字段的意外情况，给一个可配置的入口
            const currentBillId = formListenerField.billid || pk;

            // 避免表单字段的意外情况，给一个可配置的入口
            const currentBillType = formListenerField.billtype || transtype;

            // TODO 先去一下数据，保证不会出默认值的问题
            const currentBillTypeValue = that.form.getFormItemsValue(headcode, currentBillType) || {};
            const currentBillIdValue = that.form.getFormItemsValue(headcode, currentBillId) || {};

            // if (currentBillTypeValue.value && currentBillIdValue.value) {
            //     const stores = Object.keys(smartCardDataSource);

            //     stores.forEach(key => {
            //         if (key !== uniqueId) {
            //             const currentStore = smartCardDataSource[key];
            //             currentStore.setStore(['pretreatmentCardProps', currentBillId], currentBillIdValue.value, false);
            //             currentStore.setStore(['pretreatmentCardProps', currentBillType], currentBillTypeValue.value, false);
            //             // 当页面的状态变化时，重新加载显隐性
            //             that.smartCard.setCardProps(
            //                 key,
            //                 Preset.approval.cardId,
            //                 {
            //                     _billtype: _billtype,
            //                     billtype: currentBillTypeValue.value,
            //                     billid: currentBillIdValue.value,
            //                 },
            //                 false,
            //             );
            //         }
            //     });
            // }

            // 先移除 避免多次绑定
            that._handleFormApproveStateListener && that.form.removeFormItemListener(headcode, currentStatusField, that._handleFormApproveStateListener);
            that._handleFormApproveStateListener = params => {
                // console.log(params);
                const { attrcode, newValue = {}, oldValue } = params;
                const { value } = newValue;
                const stores = Object.keys(smartCardDataSource);

                const currentBillTypeValue = that.form.getFormItemsValue(headcode, currentBillType) || {};
                const currentBillIdValue = that.form.getFormItemsValue(headcode, currentBillId) || {};

                stores.forEach(key => {
                    const currentStore = smartCardDataSource[key];
                    currentStore.setStore(['pretreatmentCardProps', attrcode], value, false);

                    const prevBillType = currentStore.getStore(['pretreatmentCardProps', currentBillType]) || currentBillTypeValue.value;
                    const prevBillId = currentStore.getStore(['pretreatmentCardProps', currentBillId]) || currentBillIdValue.value;

                    currentStore.setStore(['pretreatmentCardProps', currentBillId], prevBillId, false);
                    currentStore.setStore(['pretreatmentCardProps', currentBillType], prevBillType, false);

                    if (key !== uniqueId) {
                        // 当页面的状态变化时，重新加载显隐性
                        that.smartCard.setCardProps(
                            key,
                            Preset.approval.cardId,
                            {
                                _billtype: _billtype,
                                billtype: prevBillType,
                                billid: prevBillId,
                            },
                            false,
                        );
                    }
                });
            };
            // 单据流程状态
            that.form.addFormItemListener(headcode, statusField, that._handleFormApproveStateListener);

            // 先移除 避免多次绑定
            that._handleFormBillIdListener && that.form.removeFormItemListener(headcode, currentBillId, that._handleFormBillIdListener);
            that._handleFormBillIdListener = params => {
                // console.log(params);
                const { attrcode, newValue = {}, oldValue } = params;
                const { value } = newValue;
                const stores = Object.keys(smartCardDataSource);

                const currentBillTypeValue = that.form.getFormItemsValue(headcode, currentBillType) || {};

                stores.forEach(key => {
                    const currentStore = smartCardDataSource[key];
                    const prevBillId = currentStore.getStore(['pretreatmentCardProps', attrcode]);
                    const prevBillType = currentStore.getStore(['pretreatmentCardProps', currentBillType]) || currentBillTypeValue.value;

                    currentStore.setStore(['pretreatmentCardProps', '_billtype'], _billtype, false);
                    currentStore.setStore(['pretreatmentCardProps', attrcode], value, false);
                    currentStore.setStore(['pretreatmentCardProps', currentBillType], prevBillType, false);
                    if (key !== uniqueId) {
                        // 这样调用，iframe内外都会更新
                        // that.smartCard.setCardProps(key, Preset.auditing.cardId, { _billtype: _billtype, billid: value }, false);
                        that.smartCard.setCardProps(
                            key,
                            Preset.approval.cardId,
                            {
                                _billtype: _billtype,
                                billtype: prevBillType,
                                billid: value,
                            },
                            false,
                        );
                        // 当页面的billId从有到无时，隐藏对应页签
                        if (prevBillId && !value) {
                            currentStore.setTabProps(Preset.approval.tabId, 'visible', false, false, empty, true);
                        }
                    }
                });
            };
            // 单据主键
            that.form.addFormItemListener(headcode, currentBillId, that._handleFormBillIdListener);

            // 先移除 避免多次绑定
            that._handleFormBillTypeListener && that.form.removeFormItemListener(headcode, currentBillType, that._handleFormBillTypeListener);
            that._handleFormBillTypeListener = params => {
                // console.log(params);
                const { attrcode, newValue = {}, oldValue } = params;
                const { value } = newValue;
                const stores = Object.keys(smartCardDataSource);
                const billtypeValue = value || _billtype;

                const currentBillIdValue = that.form.getFormItemsValue(headcode, currentBillId) || {};

                stores.forEach(key => {
                    const currentStore = smartCardDataSource[key];
                    const prevBillType = currentStore.getStore(['pretreatmentCardProps', attrcode]);
                    const prevBillId = currentStore.getStore(['pretreatmentCardProps', currentBillId]) || currentBillIdValue.value;

                    currentStore.setStore(['pretreatmentCardProps', 'billtype'], billtypeValue, false);
                    currentStore.setStore(['pretreatmentCardProps', attrcode], value, false);
                    currentStore.setStore(['pretreatmentCardProps', currentBillId], prevBillId, false);
                    if (key !== uniqueId) {
                        // 这样调用，iframe内外都会更新
                        // that.smartCard.setCardProps(key, Preset.auditing.cardId, { billtype: billtypeValue, transtype: value }, false);
                        that.smartCard.setCardProps(
                            key,
                            Preset.approval.cardId,
                            {
                                billtype: billtypeValue,
                                transtype: value,
                                billid: prevBillId,
                            },
                            false,
                        );
                        // 当页面的billId从有到无时，隐藏对应页签
                        if (prevBillType && !value) {
                            currentStore.setTabProps(Preset.approval.tabId, 'visible', false, false, empty, true);
                        }
                    }
                });
            };
            // 交易类型
            that.form.addFormItemListener(headcode, currentBillType, that._handleFormBillTypeListener);
        }
    }

    // 避免从url上取的单据信息不正确
    const nextBillInfo = meta.appcode && meta.pagecode ? { appcode: meta.appcode, pagecode: meta.pagecode } : {};

    stores.forEach(key => {
        // 初始化billInfo 一般用于缓存
        const { appcode, pagecode } = smartCardDataSource[key].getStore('billInfo');
        if (!appcode || !pagecode) {
            smartCardDataSource[key].setBillInfo(nextBillInfo, false);
        }

        smartCardDataSource[key].setStore('ts', currentTs, false);
        smartCardDataSource[key].setMetaLang(metaLang);
        smartCardDataSource[key].setMeta(layout, key);
    });


    // 要先初始化模板，否则属性设置会不生效
    if (metaJson) {
        const { billtype, head = {}, headcode } = metaJson;
        const { clazz, metaid, pk, billfield = {} } = head;
        const { approvestate = {}, billtype: sameBillType, transtype } = billfield;
        let { statusField, statusValue } = approvestate;
        const formListenerField = this.smartCardDataSource[uniqueId].getStore('formListenerField') || {};
        if (this.formDataSource && this.formDataSource[headcode] && pk) {
            const that = this;
            const _billtype = billtype;

            // 避免表单字段的意外情况，给一个可配置的入口
            const currentStatusField = formListenerField.approvestate || statusField;

            // 避免表单字段的意外情况，给一个可配置的入口
            const currentBillId = formListenerField.billid || pk;

            // 避免表单字段的意外情况，给一个可配置的入口
            const currentBillType = formListenerField.billtype || transtype;

            // TODO 先去一下数据，保证不会出默认值的问题
            const currentBillTypeValue = that.form.getFormItemsValue(headcode, currentBillType) || {};
            const currentBillIdValue = that.form.getFormItemsValue(headcode, currentBillId) || {};

            if (currentBillTypeValue.value && currentBillIdValue.value) {
                const stores = Object.keys(smartCardDataSource);

                stores.forEach(key => {
                    if (key !== uniqueId) {
                        const currentStore = smartCardDataSource[key];
                        currentStore.setStore(['pretreatmentCardProps', currentBillId], currentBillIdValue.value, false);
                        currentStore.setStore(['pretreatmentCardProps', currentBillType], currentBillTypeValue.value, false);
                        // 当页面的状态变化时，重新加载显隐性
                        that.smartCard.setCardProps(
                            key,
                            Preset.approval.cardId,
                            {
                                _billtype: _billtype,
                                billtype: currentBillTypeValue.value,
                                billid: currentBillIdValue.value,
                            },
                            false,
                        );
                    }
                });
            }
        }
    }
}

/**
 * 给特殊情况使用，初始化store的一些属性 (一般只给iframe外使用),在output里做了拦截，取iframe内的一些数据
 * @memberof SmartCard
 * @param {SmartCardId} id  组件id
 * @param {StoreData} data 组件配置数据
 * @param {boolean} [shouldForceUpdate = true] 是否更新
 * @returns {StoreData}
 */
function initSmartCard(id, data, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    const { config, layout, billInfo = {}, sceneName, ts, metaLang, containerProps, tabsProps, walletProps, cardProps, approveProps = {}, auditingProps = {} } = data;
    currentStore.setStore('id', id, false);
    currentStore.setBillInfo(billInfo, false);
    currentStore.setStore('ts', ts, false);
    currentStore.setMetaLang(metaLang);

    const currentSceneName = currentStore.getScene();

    // 解决共享我的审核节点的单页模式导致的默认激活页签第二次不生效的问题，重置一下属性
    currentStore.setStore('pretreatmentState', {}, false);

    let meta = layout;
    const SceneDefaultName = '__default';
    // 外部的场景不等于内部的  说明内部场景先切换了 外部没有识别到执行  切换下外部场景
    if (sceneName !== currentSceneName) {
        const name = sceneName || SceneDefaultName;
        const { sceneMeta } = currentStore.getSceneData(name);
        if (sceneMeta.length) {
            currentStore.setStore('scene', name, false);
            meta = currentStore.getCacheMeta(id, meta, name);
        }
    }

    // 属性的同步  卡片的属性再看
    currentStore.setStore('containerProps', containerProps);
    currentStore.setStore('tabsProps', tabsProps);
    currentStore.setStore('walletProps', walletProps);
    currentStore.setStore('cardProps', cardProps);

    // 初始化
    currentStore.setMeta(meta, id, false);

    // 更新默认的两个页签的属性
    for (let key in approveProps) {
        currentStore.setCardProps(Preset.approval.cardId, key, approveProps[key], false, {
            active: false,
            affectOriginVisible: false,
        });
    }
    for (let key in auditingProps) {
        currentStore.setCardProps(Preset.auditing.cardId, key, auditingProps[key], false, {
            active: false,
            affectOriginVisible: false,
        });
    }
    // 重新判断两个页签是否要显示
    currentStore.reloadPretreatmentCard([Preset.auditing.cardId, Preset.approval.cardId], undefined);

    // 提前切换全局对象
    // 解决iframe外get方法获取不了数据的问题
    const pageInstance = this;
    Portal.installGlobal(pageInstance, id);

    shouldForceUpdate && currentStore.forceUpdate();
    return data;
}

/**
 * 给特殊情况使用，初始化store的一些属性 （一般只给iframe内使用）
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {StoreData} data 组件配置数据
 * @returns {StoreData}
 */
function getSmartCardData(id) {
    const currentStore = getStore.call(this, id);
    id = currentStore.getStore('id') || id;
    const nextMeta = currentStore.getMeta();
    const metaLang = currentStore.getMetaLang();
    const currentTs = currentStore.getStore('ts');
    const config = currentStore.getStore('config');
    const sceneName = currentStore.getScene();
    const nextBillInfo = currentStore.getStore('billInfo');
    const containerProps = currentStore.getStore('containerProps');
    const tabsProps = currentStore.getStore('tabsProps');
    const walletProps = currentStore.getStore('walletProps');
    const cardProps = currentStore.getStore('cardProps');

    // 审批中心和智能审核的参数传递
    const approveProps = currentStore.getCardProps(Preset.approval.cardId);
    const auditingProps = currentStore.getCardProps(Preset.auditing.cardId);

    return {
        layout: nextMeta,
        id: id,
        config: config,
        billInfo: nextBillInfo,
        metaLang: metaLang,
        ts: currentTs,
        approveProps,
        auditingProps,
        sceneName,
        containerProps,
        tabsProps,
        walletProps,
        cardProps,
    };
}

/**
 * 创建卡片容器
 * @memberof SmartCard
 * @param {SmartCardId} id  组件id
 * @param {object} config 组件配置项
 * @returns {ReactNode}
 */
function createSmartCard(id, config = {}) {
    const currentStore = getStore.call(this, id);

    if (!currentStore) {
        return <div tip="没有id导致store没有"></div>;
    }

    currentStore.setStore('config', config, false);

    return <SmartCard {...config} pageInstance={this} id={id} store={currentStore} />;
}

// 获取当前模板
function getViewMeta(id) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.getViewMeta(id);
    return res;
}

/**
 * 设置组件属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {SmartCardConfig} props 组件属性，eg. expectActiveTab等
 * @param {boolean} [shouldForceUpdate = true] 是否更新视图
 */
function setSmartCardProps(id, props = {}, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    for (let key in props) {
        currentStore.setStore(key, props[key], false);
    }
    shouldForceUpdate && currentStore.forceUpdate();
}

/**
 * 设置区域属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {ContainerConfig} props 容器属性，eg. visible、expanded等
 * @param {boolean} [shouldForceUpdate = true] 是否更新视图
 */
function setContainerProps(id, props = {}, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    for (let key in props) {
        if (key === 'activeKey') {
            currentStore.setContainerActiveTab(props[key], false);
        }
        currentStore.setContainerProps(key, props[key], false);
    }
    shouldForceUpdate && currentStore.forceUpdate();
}

/**
 * 获取区域属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} key ContainerConfig里对应的key
 * @returns {ContainerConfig.value}
 */
function getContainerProps(id, key) {
    const currentStore = getStore.call(this, id);
    let res = null;
    if (key === 'activeKey') {
        res = currentStore.getContainerActiveTab();
    } else {
        res = currentStore.getContainerProps(key);
    }
    return res;
}

/**
 * 设置激活页签
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} value 页签的id
 * @param {boolean} [shouldForceUpdate = true] 是否更新
 */
function setContainerActiveTab(id, value, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    currentStore.setContainerActiveTab(value, false);
    shouldForceUpdate && currentStore.forceUpdate();
}

/**
 * 获取激活页签
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @returns {string}
 */
function getContainerActiveTab(id) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.getContainerActiveTab();
    return res;
}

/**
 * 设置区域显隐性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {boolean} value 组件显隐性
 * @param {boolean} [shouldForceUpdate = true] 是否更新
 */
function setContainerVisible(id, value, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    currentStore.setContainerProps(['visible'], value, false);
    shouldForceUpdate && currentStore.forceUpdate();
}

/**
 * 获取区域显隐性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @returns {boolean}
 */
function getContainerVisible(id) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.getContainerProps(['visible']);
    return res;
}

/**
 * 获取所有的页签
 * @memberof SmartCard
 * @param {SmartCardId} id  组件id
 * @returns {array<TabConfig>}
 */
function getTabs(id) {
    const currentStore = getStore.call(this, id);
    const tabs = currentStore.getTabs();
    const res = tabs.map(tab => {
        const { props = {} } = tab || {};
        const { moduleId } = props;
        const currentProps = currentStore.getTabProps(moduleId) || {};
        return { ...props, ...currentProps };
    });
    return res;
}

/**
 * 获取所有显示的页签
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @returns {array<TabConfig>}
 */
function getVisibleTabs(id) {
    const currentStore = getStore.call(this, id);
    const tabs = currentStore.getTabs(props => {
        return props.visible;
    });
    const res = tabs.map(tab => {
        const { props = {} } = tab || {};
        const { moduleId } = props;
        const currentProps = currentStore.getTabProps(moduleId) || {};
        return { ...props, ...currentProps };
    });
    return res;
}

/**
 * 获取页签属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} tabId 页签id，对应TabConfig里的moduleId
 * @param {string} key TabConfig里的key
 * @returns {TabConfig.value}
 */
function getTabProps(id, tabId, key) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.getTabProps(tabId, key);
    return res;
}

/**
 * 设置页签属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} tabId 页签id，对应TabConfig里的moduleId
 * @param {TabConfig} props 页签配置项
 * @param {boolean} [shouldForceUpdate = true] 是否更新
 */
function setTabProps(id, tabId, props = {}, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    for (let key in props) {
        currentStore.setTabProps(tabId, key, props[key], false);
    }
    shouldForceUpdate && currentStore.forceUpdate();
}

/**
 * 获取某个页签下所有卡片夹
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} tabId  页签id
 * @returns {array<WalletCardConfig>}
 */
function getCardWallets(id, tabId) {
    const currentStore = getStore.call(this, id);
    const wallets = currentStore.getCardWallets(tabId);
    const res = wallets.map(wallet => {
        const { props = {} } = wallet || {};
        const { moduleId } = props;
        const currentProps = currentStore.getCardWalletProps(moduleId) || {};
        return { ...props, ...currentProps };
    });
    return res;
}

/**
 * 获取显示的卡片夹
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} tabId  页签id
 * @returns {array<WalletCardConfig>}
 */
function getVisibleCardWallets(id, tabId) {
    const currentStore = getStore.call(this, id);
    const wallets = currentStore.getCardWallets(tabId, props => {
        return props.visible;
    });
    const res = wallets.map(wallet => {
        const { props = {} } = wallet || {};
        const { moduleId } = props;
        const currentProps = currentStore.getCardWalletProps(moduleId) || {};
        return { ...props, ...currentProps };
    });
    return res;
}

/**
 * 获取卡片夹属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} walletId 卡片夹id
 * @param {string} key WalletConfig.key
 * @returns {WalletConfig.value}
 */
function getCardWalletProps(id, walletId, key) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.getCardWalletProps(walletId, key);
    return res;
}

/**
 * 设置卡片夹属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} walletId 卡片夹id
 * @param {WalletConfig} props 卡片夹属性
 * @param {boolean} [shouldForceUpdate = true] 是否更新
 */
function setCardWalletProps(id, walletId, props = {}, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    for (let key in props) {
        currentStore.setCardWalletProps(walletId, key, props[key], false, {});
    }
    shouldForceUpdate && currentStore.forceUpdate();
}

/**
 * 获取某个页签下的某个组内的卡片
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} tabId 页签id
 * @param {string} walletId 卡片夹id
 * @returns {array<WalletCardConfig>}
 */
function getCards(id, tabId, walletId) {
    const currentStore = getStore.call(this, id);
    const cards = currentStore.getCards(tabId, walletId);
    const res = cards.map(card => {
        const { props = {} } = card || {};
        const { moduleId } = props;
        const currentProps = currentStore.getCardProps(moduleId) || {};
        return { ...props, ...currentProps };
    });
    return res;
}

/**
 * 获取某个页签下的某个组内显示的卡片
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} tabId 页签id
 * @param {string} walletId 卡片夹id
 * @returns {array<WalletCardConfig>}
 */
function getVisibleCards(id, tabId, walletId) {
    const currentStore = getStore.call(this, id);
    const cards = currentStore.getCards(tabId, walletId, props => {
        return props.visible;
    });
    const res = cards.map(card => {
        const { props = {} } = card || {};
        const { moduleId } = props;
        const currentProps = currentStore.getCardProps(moduleId) || {};
        return { ...props, ...currentProps };
    });
    return res;
}

/**
 * 获取卡片属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} cardId 卡片id
 * @param {string} key WalletCardConfig.key
 * @returns {WalletCardConfig.value}
 */
function getCardProps(id, cardId, key) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.getCardProps(cardId, key);
    return res;
}

/**
 * 设置卡片属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} cardId 卡片id
 * @param {WalletCardConfig} props 卡片属性
 * @param {boolean} [shouldForceUpdate = true]  是否更新
 */
function setCardProps(id, cardId, props = {}, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    for (let key in props) {
        currentStore.setCardProps(cardId, key, props[key], false, {
            active: true,
            affectOriginVisible: false,
        });
    }

    // 判断下预置页签是否显示  更新一次
    if ([Preset.auditing.cardId, Preset.approval.cardId].includes(cardId)) {
        currentStore.reloadPretreatmentCard([cardId], undefined);
        shouldForceUpdate && currentStore.forceUpdate();
    } else {
        shouldForceUpdate && currentStore.forceUpdate();
    }
}

/**
 * 设置多个卡片相同的属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {array<string>} cardIds 卡片ids
 * @param {WalletCardConfig} props 卡片属性
 * @param {boolean} [shouldForceUpdate = true]  是否更新
 */
function setCardsSameProps(id, cardIds = [], props = {}, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);
    cardIds = isArray(cardIds) ? cardIds : [cardIds];

    const PresetCardIds = [Preset.auditing.cardId, Preset.approval.cardId];
    let hasPresetCardIds = [];

    cardIds.forEach(cardId => {
        for (let key in props) {
            currentStore.setCardProps(cardId, key, props[key], false, {
                active: true,
                affectOriginVisible: false,
            });
        }

        if (PresetCardIds.includes(cardId)) {
            hasPresetCardIds.push(cardId);
        }
    });

    // 判断下预置页签是否显示  更新一次
    if (hasPresetCardIds.length) {
        currentStore.reloadPretreatmentCard(hasPresetCardIds, undefined);
        shouldForceUpdate && currentStore.forceUpdate();
    } else {
        shouldForceUpdate && currentStore.forceUpdate();
    }
}

/**
 * 设置多个卡片的属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {object<cardId, WalletCardConfig>} cardProps 多个卡片的属性对象
 * @param {boolean} [shouldForceUpdate = true]  是否更新
 */
function setCardsProps(id, cardProps = {}, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, id);

    const PresetCardIds = [Preset.auditing.cardId, Preset.approval.cardId];
    let hasPresetCardIds = [];

    for (const cardId in cardProps) {
        if (Object.hasOwnProperty.call(cardProps, cardId)) {
            const props = cardProps[cardId] || {};
            for (let key in props) {
                currentStore.setCardProps(cardId, key, props[key], false, {
                    active: true,
                    affectOriginVisible: false,
                });
            }
        }

        if (PresetCardIds.includes(cardId)) {
            hasPresetCardIds.push(cardId);
        }
    }

    // 判断下预置页签是否显示  更新一次
    if (hasPresetCardIds.length) {
        currentStore.reloadPretreatmentCard(hasPresetCardIds, undefined);
        shouldForceUpdate && currentStore.forceUpdate();
    } else {
        shouldForceUpdate && currentStore.forceUpdate();
    }
}

/**
 * 获取卡片的实例
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} cardId 卡片id
 * @returns {CardInstance}
 */
function getCardInstance(id, cardId) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.getCardInstance(cardId);
    return res;
}

/**
 * 获取卡片实例的方法和属性
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {string} cardId 卡片id
 * @param {string} name 实例属性名
 * @returns {object}
 */
function getCardInstanceMethods(id, cardId, name) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.getCardInstance(cardId);
    return res[name];
}

/**
 * 创建页签等模拟数据，一般用于扩展自定义页签
 * @memberof SmartCard
 * @param {SmartCardId} id 组件id
 * @param {object} config 创建项的配置参数
 * @param {string} [type = 'tab'] 默认创建页签
 * @returns {object}
 */
function createItem(id, config, type) {
    const currentStore = getStore.call(this, id);
    const res = currentStore.createItem(config, type);
    return res;
}

/**
 * 监听事件
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} eventName 事件名
 * @param {function} callback 回调方法
 */
function addEventListener(moduleId, eventName, callback) {
    const currentStore = getStore.call(this, moduleId);
    currentStore.addEventListener(eventName, callback);
}

/**
 * 移除事件
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} eventName 事件名
 * @param {function} callback 回调方法
 */
function removeEventListener(moduleId, eventName, callback) {
    const currentStore = getStore.call(this, moduleId);
    currentStore.removeEventListener(eventName, callback);
}

/**
 * 触发事件
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} eventName 事件名
 */
function triggerEventListener(moduleId, eventName) {
    const currentStore = getStore.call(this, moduleId);
    currentStore.triggerEventListener(eventName);
}

/**
 * 设置当前场景
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} name 场景名称
 * @param {boolean} [shouldForceUpdate=true] 是否更新
 * @param {function} callback 设置成功更新后回调
 */
function setScene(moduleId, name, shouldForceUpdate = true, callback) {
    const currentStore = getStore.call(this, moduleId);
    currentStore.setScene(name, shouldForceUpdate, callback);
}

/**
 * 获取当前场景
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @returns {string}
 */
function getScene(moduleId) {
    const currentStore = getStore.call(this, moduleId);
    const result = currentStore.getScene();
    return result;
}

/**
 * 设置场景数据
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} name 场景名称
 * @param {SceneData} data 场景数据
 * @param {boolean} [isSort=false] 是否更新场景数据排序
 */
function setSceneData(moduleId, name, data, isSort = false) {
    const currentStore = getStore.call(this, moduleId);
    data = isSort ? data : currentStore.sortSceneDataByMeta(name, data);
    currentStore.setSceneData(name, data);
}

/**
 * 设置场景数据(除传入数据之外)
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} name 场景名称
 * @param {SceneData} data 场景数据
 */
function setSceneRemainData(moduleId, name, data) {
    const currentStore = getStore.call(this, moduleId);

    let nextData = currentStore.remainSceneDataByMeta(name, data);

    // 未知的数据排不了序
    // nextData = isSort ? nextData : currentStore.sortSceneDataByMeta(name, nextData);

    currentStore.setSceneData(name, nextData);
}

/**
 * 设置卡片组场景数据
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} name 场景名称
 * @param {SceneWalletData} data 场景数据
 * @param {boolean} [shouldForceUpdate=true] 是否更新
 * @param {boolean} [isSort=false] 是否更新场景数据排序
 */
function setWalletPartSceneData(moduleId, name, data, shouldForceUpdate = true, isSort = false) {
    const currentStore = getStore.call(this, moduleId);
    currentStore.setWalletPartSceneData(name, data, shouldForceUpdate, isSort);
}

/**
 * 设置卡片组场景数据(除传入数据之外)
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} name 场景名称
 * @param {SceneWalletData} data 场景数据
 * @param {boolean} [shouldForceUpdate=true] 是否更新
 */
function setWalletPartSceneRemainData(moduleId, name, data, shouldForceUpdate = true) {
    const currentStore = getStore.call(this, moduleId);
    // 处理下数据
    let nextData = currentStore.remainSceneDataByMeta(name, {
        children: data,
        moduleId,
    });
    nextData = nextData.children || [];
    // 未知的数据排不了序
    currentStore.setWalletPartSceneData(name, nextData, shouldForceUpdate, false);
}

/**
 * 获取场景数据
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} name 场景名称
 * @returns {SceneData}
 */
function getSceneData(moduleId, name) {
    const currentStore = getStore.call(this, moduleId);
    const { sceneData, sceneMeta } = currentStore.getSceneData(name);
    return sceneData;
}

/**
 * 获取场景下完整布局数据
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} name 场景名称
 * @returns {array}
 */
function getSceneMeta(moduleId, name) {
    const currentStore = getStore.call(this, moduleId);
    const { sceneData, sceneMeta } = currentStore.getSceneData(name);
    return sceneMeta;
}

/**
 * 设置单据信息，一般用于缓存等操作，不更新组件，建议在组件渲染完成前设置（模板setMeta前）。
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} name 场景名称
 * @param {BillInfo} billInfo 单据信息
 * @param {boolean} [forceUpdate=false]
 */
function setBillInfo(moduleId, billInfo, forceUpdate = false) {
    const currentStore = getStore.call(this, moduleId);
    currentStore.setBillInfo(billInfo, forceUpdate);
}

/**
 * 设置要监控单据的属性，一般给审批流程使用。
 * @memberof SmartCard
 * @param {SmartCardId} moduleId 组件id
 * @param {string} key 监控目标名称
 * @param {string} value 对应表单名称
 */
function setFormListenerField(moduleId, key, value) {
    if (key) {
        this.smartCardDataSource = this.smartCardDataSource || {};
        let uniqueStore = this.smartCardDataSource[uniqueId];
        // 根据ts 判断用户级缓存
        if (!uniqueStore) {
            // 先走了getStore
            this.smartCardDataSource[uniqueId] = uniqueStore = useSmartCard({ id: uniqueId });
        }
        uniqueStore.setStore(['formListenerField', key], value, false);
    }
}

export {
    init,
    createSmartCard,
    // 暂不提供给业务
    // getViewMeta,
    createItem,
    setContainerVisible,
    getContainerVisible,
    setContainerProps,
    getContainerProps,
    setContainerActiveTab,
    getContainerActiveTab,
    getTabs,
    getVisibleTabs,
    getTabProps,
    setTabProps,
    getCardWallets,
    getVisibleCardWallets,
    getCardWalletProps,
    setCardWalletProps,
    getCards,
    getVisibleCards,
    getCardProps,
    setCardProps,
    setCardsSameProps,
    setCardsProps,
    getCardInstance,
    getCardInstanceMethods,
    addEventListener,
    removeEventListener,
    triggerEventListener,
    setScene,
    getScene,
    setSceneData,
    getSceneData,
    getSceneMeta,
    setWalletPartSceneData,
    setSceneRemainData,
    setWalletPartSceneRemainData,
    setBillInfo,
    initSmartCard,
    getSmartCardData,
    setSmartCardProps,
    setFormListenerField,
};
